import { render, staticRenderFns } from "./GeneralCategoryTab.vue?vue&type=template&id=25a6a406&scoped=true"
import script from "./GeneralCategoryTab.vue?vue&type=script&lang=js"
export * from "./GeneralCategoryTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralCategoryTab.vue?vue&type=style&index=0&id=25a6a406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6a406",
  null
  
)

export default component.exports